module.exports = __webpack_public_path__ + "static/media/alien.aacf3f24.jpg";